module.exports = __webpack_public_path__ + "img/DEVICES_Other.eecd2ff4.svg";